import { VIEW_PAYMENT } from "@hopper-b2b/types";
import { trackBaseEvent } from "../utils";

export const trackViewPaymentMethods = async (context) =>
  trackBaseEvent(context, {
    eventName: VIEW_PAYMENT,
    properties: {},
  });
